export default "__VITE_ASSET__24a9b914__"